import styled, { keyframes } from 'styled-components';
import { paletteHelper, spacingHelper } from '@property.com.au/ui-kit';

const pulse = keyframes`
    0% {
        transform: scale(0.0);
    }
    40% {
        transform: scale(1);
    }
    80% {
        transform: scale(0.0);
    }
    100% {
        transform: scale(0.0);  
    }

`;

export const LoadingDotsContainer = styled.div.attrs({ role: 'status' })`
  display: flex;
  align-items: center;
  gap: ${spacingHelper('twoExtraSmall')};
`;

const Dot = styled.div<{ delay?: string }>`
  width: ${spacingHelper('extraSmall')};
  height: ${spacingHelper('extraSmall')};
  border-radius: 50%;
  background-color: ${paletteHelper('textPrimary')};
  animation: ${pulse} 1.5s infinite ease-in-out;
  animation-delay: ${(props) => props.delay || '0s'};
`;

export const LoadingDots = () => (
  <LoadingDotsContainer>
    <Dot />
    <Dot delay="0.25s" />
    <Dot delay="0.5s" />
  </LoadingDotsContainer>
);
